import styled from '@emotion/styled';
import { Button, Typography } from '@material-ui/core';
import Edit from '@material-ui/icons/Edit';
import { ClassAttributes, createElement, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { SingleAssignmentFragment } from '../../../../generated/graphql_offer';
import { SPACING_UNIT } from '../../../constant/spacing';
import CompleteDialog from './CompleteDialog';

interface Props extends ClassAttributes<HTMLElement> {
  assignment: SingleAssignmentFragment;
  reload: () => Promise<unknown>;
  className?: string;
}

const CompleteButton = ({ assignment, reload, className }: Props) => {
  const [isDialogOpen, setDialogOpen] = useState(false);

  return (
    <Root className={className}>
      <Button
        size="large"
        color="primary"
        variant="contained"
        onClick={() => {
          setDialogOpen(true);
        }}
      >
        <Edit />
        <ButtonText>
          <FormattedMessage id="reputation.title" />
        </ButtonText>
      </Button>
      <CompleteDialog
        assignmentId={assignment.id}
        isOpen={isDialogOpen}
        closeDialog={() => {
          setDialogOpen(false);
        }}
        reload={reload}
      />
    </Root>
  );
};

const Root = styled('div')({
  display: 'inline-block',
  lineHeight: 1,
});

const ButtonText = styled(Typography)({
  marginLeft: SPACING_UNIT / 2,
  color: 'inherit',
});

export default CompleteButton;
